/*# sourceMappingURL=tube-characteristics.component-WVCU3D23.css.map */
